<script>
    import clsx from 'clsx';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    export let open = false;
    export let disabled = false;
    export let language = '';
    export let twoColumn = false;
    export let handleClear;
    export let handleSave;

    const translations = {
        de: {
            clear: 'Löschen',
            save: 'Speichern',
        },
        en: {
            clear: 'Clear',
            save: 'Save',
        },
    };

    let btnClasses;

    const borderRadius = getBorderRadius('button');

    $: btnClasses = clsx(
        borderRadius,
        `focus:before:${borderRadius}`,
        'w-full relative h-12 py-2 px-3 text-center text-sm font-medium disabled:opacity-70 focus:before:content-[""] focus:before:absolute focus:before:-top-0.5 focus:before:-right-0.5 focus:before:-left-0.5 focus:before:-bottom-0.5 focus:before:border focus:before:border-blue-600',
    );
</script>

<div class="grid w-full grid-cols-2 gap-2 bg-white px-6 py-4 pt-0" class:col-span-2={twoColumn}>
    <button
        {disabled}
        on:click={handleClear}
        class={`${btnClasses} bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-600 disabled:text-gray-500 disabled:hover:bg-gray-100`}
        tabindex={open ? '0' : '-1'}>{translations[language].clear}</button
    >
    <button
        {disabled}
        on:click={handleSave}
        class={`${btnClasses} disabled:hover:bg-unset bg-blue-500 text-white hover:bg-blue-600 disabled:bg-blue-300`}
        tabindex={open ? '0' : '-1'}>{translations[language].save}</button
    >
</div>
